import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { StudentService } from 'src/app/services/Student/student.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import * as moment from 'moment';

@Component({
  selector: 'app-student-details',
  templateUrl: './student-details.component.html',
  styleUrls: ['./student-details.component.css']
})
export class StudentDetailsComponent implements OnInit {

  constructor(private studentService: StudentService,
    private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService,
    public globalHelper: GlobalHelper) { }

    
    BranchDetails: any;
   
    FilterStudentAdmissionModel = {
        ClassID: 0,
        ParentID: 0,
        Print: "",
        SectionID: 0,
        StudentStatus: 0,
        BranchID: 0,
        SessionID: 0,
        FirstName: '',
        FromDate: '',
        ToDate: '',
        RegistrationNumber: '',
        StudentNo: '',
        CurrentIndex: 0,
        PageSize: 20,
        LocationID: 0,
        CategoryID:0,
    }
   
    currentPage = 1;
    pageSize = 20;
    recordCount = 0;
    totalPages = 0;
    
    numberOfPages() {
        this.totalPages = Math.ceil(this.recordCount / this.pageSize);
    }

    nextPage() {
        this.currentPage = this.currentPage + 1;
    }

    pageSizes() {
        this.currentPage = 1;
        this.recordCount = 0;
        this.totalPages = 0;
    }

    
    loadingSearch = true;
    ListStuAdmission: any;
    SearchStudentDetails() {
        this.spinnerService.show();
        this.FilterStudentAdmissionModel.CurrentIndex = this.currentPage;
        this.FilterStudentAdmissionModel.PageSize = this.pageSize;
        this.loadingSearch = true;
        this.FilterStudentAdmissionModel.FromDate = this.FilterStudentAdmissionModel.FromDate != null && this.FilterStudentAdmissionModel.FromDate != "" ? moment(this.FilterStudentAdmissionModel.FromDate).format('DD-MMM-YYYY') : "";
        this.FilterStudentAdmissionModel.ToDate = this.FilterStudentAdmissionModel.ToDate != null && this.FilterStudentAdmissionModel.ToDate != "" ? moment(this.FilterStudentAdmissionModel.ToDate).format('DD-MMM-YYYY') : "";

        this.studentService.SearchStudentDetails(JSON.stringify(this.FilterStudentAdmissionModel)).subscribe((data) => {
            this.ListStuAdmission = data.ListStuAdmission;
            this.spinnerService.hide();
            this.recordCount = 0;
            if (data.ListStuAdmission != null && data.ListStuAdmission.length > 0) {
                this.recordCount = data.ListStuAdmission[0].RecordCount;
            }

            this.loadingSearch = false;
            this.numberOfPages();

        });
    };

    GetCategory() {
        this.lookupService.GetLookupsList('Category', '').subscribe((data) => {
            this.CategoryList = data.LookupItems;
        });

    };
    CategoryList: any;
    ClassList: any;
    GetClass() {

        this.lookupService.GetLookupsList('Class', '').subscribe((data) => {
            this.ClassList = data.LookupItems;           

        });

    };
    SectionSearchList: any;
    GetSectionSearch() {
        this.FilterStudentAdmissionModel.SectionID = 0;
        var ItemBo = {
            'ItemId': this.FilterStudentAdmissionModel.ClassID
        }
        this.lookupService.GetLookupsList('SectionName', JSON.stringify(ItemBo)).subscribe((data) => {
            this.SectionSearchList = data.LookupItems;

        });
    };

    StudentStatusList: any;
    GetStudentStatus() {

        this.lookupService.GetLookupsList('StudentStatus', '').subscribe((data) => {
            this.StudentStatusList = data.LookupItems;

        });
    };
   
    StudentLocationList: any; CourseList: any;
    GetLocation() {

        this.lookupService.GetLookupsList('Location', '').subscribe((data) => {
            this.StudentLocationList = data.LookupItems;

        });
    };
   
    Clear() {
        this.FilterStudentAdmissionModel = {
            ClassID: 0,
            ParentID: 0,
            Print: "",
            SectionID: 0,
            StudentStatus: 0,
            BranchID: 0,
            SessionID: 0,
            FirstName: '',
            FromDate: '',
            ToDate: '',
            RegistrationNumber: '',
            StudentNo: '',
            CurrentIndex: 0,
            PageSize: 20,
            LocationID: 0,
            CategoryID:0,
        }
      this.SearchStudentDetails();
    };

    FilePath: any;

    loadingDownload = false;
    SearchStudentDetailsDownload() {
        this.FilterStudentAdmissionModel.FromDate = this.FilterStudentAdmissionModel.FromDate != null && this.FilterStudentAdmissionModel.FromDate != "" ? moment(this.FilterStudentAdmissionModel.FromDate).format('DD-MMM-YYYY') : "";
        this.FilterStudentAdmissionModel.ToDate = this.FilterStudentAdmissionModel.ToDate != null && this.FilterStudentAdmissionModel.ToDate != "" ? moment(this.FilterStudentAdmissionModel.ToDate).format('DD-MMM-YYYY') : "";

        this.spinnerService.show();
        this.FilterStudentAdmissionModel.CurrentIndex = 0;
        this.FilterStudentAdmissionModel.PageSize = 0;
        this.FilterStudentAdmissionModel.Print = 'XLS';
        this.loadingDownload = true;
        this.studentService.SearchStudentDetailsDownload(JSON.stringify(this.FilterStudentAdmissionModel)).subscribe((data) => {
            this.spinnerService.hide();
            this.FilePath = data.FilePath;
            window.location = data.FilePath;
            this.loadingDownload = false;

        });
    };

   

    Print() {

        if (this.FilterStudentAdmissionModel.ClassID != 0) {
            var url = "studentlistingreport?ReportType=PrintStudentList&ClassID=" + this.FilterStudentAdmissionModel.ClassID + "&SectionID=" + this.FilterStudentAdmissionModel.SectionID + "&SessionID=" + this.FilterStudentAdmissionModel.SessionID + "&StudentStatus=" + this.FilterStudentAdmissionModel.StudentStatus + "&ParentID=" + this.FilterStudentAdmissionModel.ParentID + "&StudentNo=" + this.FilterStudentAdmissionModel.StudentNo + "&RegistrationNumber=" + this.FilterStudentAdmissionModel.RegistrationNumber + "&FirstName=" + this.FilterStudentAdmissionModel.FirstName;
            this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
        }
        else {
            alert('please select Class')
        }
    };





    ngOnInit() {
      
        // this.GetCategory();
        // this.GetLocation();
        // this.GetStudentStatus();
        this.GetClass();
       
    }


   
}
